/** @format */
import { ImageWithCaption } from '@mpb-com/feather/components/atoms/image-with-caption';
import React from 'react';
import { ReactCompareSlider } from 'react-compare-slider';

import { ContentfulCaption } from '@toucan/client/features/contentful/components/caption';
import { ContentfulPicture } from '@toucan/client/features/contentful/components/picture';

import { ContentfulImageCompareProps } from './type';

export const ContentfulImageCompare = ({
    leftImage,
    rightImage,
    caption,
}: ContentfulImageCompareProps) => {
    if (!leftImage.url || !rightImage.url) {
        return null;
    }

    return (
        <div className="image-compare-wrapper">
            <ImageWithCaption
                image={
                    <ReactCompareSlider
                        itemOne={<ContentfulPicture image={leftImage} />}
                        itemTwo={<ContentfulPicture image={rightImage} />}
                    />
                }
                caption={<ContentfulCaption caption={caption} />}
            />
        </div>
    );
};
